import { Col, Container, Row } from "react-bootstrap";
import AmenityForm from "../../../Components/Forms/AmenityForm/AmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditAmenityMutation, useGetAmenityByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";
import useUploadImage from "../../../Hooks/UseUploadImage/useUploadImageHook";

export default function EditAmenityPage() {

    const { amenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetAmenityByIdQuery(amenityId, { skip: !amenityId })
    const amenityData = data || {}

    const [
        editAmenity,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditAmenityMutation()

    const { uploadImageFn } = useUploadImage()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedAmenity = await editAmenity({
            amenityId: amenityId,
            amenityInfo: values
        }).unwrap()
        if (updatedAmenity._id) {
            dispatch(navigateTo(`/amenity/${updatedAmenity._id}`))
        }
        return updatedAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {amenityId && amenityData && !isLoading && (
                        <AmenityForm
                            initialValues={{
                                ...amenityData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                            uploadImageFn={uploadImageFn}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
